import { t as gsapWithCSS } from "@theme/gsap";
import { r as refreshScrollTrigger } from "@theme/gsap-utils";
//#region frontend/islands/details-disclosure.js
var DetailsDisclosure = class extends HTMLElement {
	connectedCallback() {
		this.details = this.querySelector("details");
		this.panel = this.details.querySelector("summary").nextElementSibling;
		this.caret = this.querySelector("svg");
		this.summary = this.querySelector("summary");
		gsapWithCSS.set(this.panel, {
			height: 0,
			overflow: "hidden"
		});
		this.summary.addEventListener("click", (e) => {
			e.preventDefault();
			this.details.open ? this.close() : this.open();
		});
	}
	open() {
		this.details.open = true;
		gsapWithCSS.to(this.panel, {
			height: this.panel.scrollHeight,
			duration: .4,
			autoAlpha: 1,
			ease: "power3.out",
			overwrite: "auto",
			onComplete: () => {
				gsapWithCSS.set(this.panel, {
					height: "auto",
					overflow: "visible"
				});
				refreshScrollTrigger();
			}
		});
		if (this.caret) gsapWithCSS.to(this.caret, {
			rotate: 180,
			duration: .3,
			ease: "power3.out",
			overwrite: "auto"
		});
	}
	close() {
		gsapWithCSS.fromTo(this.panel, { height: this.panel.getBoundingClientRect().height }, {
			height: 0,
			duration: .4,
			autoAlpha: 0,
			ease: "power3.out",
			overwrite: "auto",
			onComplete: () => {
				this.details.open = false;
				refreshScrollTrigger();
			}
		});
		if (this.caret) gsapWithCSS.to(this.caret, {
			rotate: 0,
			duration: .3,
			ease: "power3.in",
			overwrite: "auto"
		});
	}
};
window.customElements.define("details-disclosure", DetailsDisclosure);
//#endregion
export { DetailsDisclosure as default };
